import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import EpicStepDetail from '../../RifoDesign/EpicStepDetail/epic.step.detail.vue';
import { CommonConfig } from '../../configs/config.common';

@Component({
    components: {
        'layout': EpicStandardLayout,
        EpicStepDetail
    }
})
export default class EpicHomeServicesPage extends Vue {
    public data: string = '';

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public configs = new CommonConfig();

    public detail = [{
        name: 'We look after all', preText:
            'Just enjoy your life with worry less, our professional agents will take care of all the mess of house services.',
        detailList: [], afterText: '', btnTex: '', btnHref: ''
    }];

    public created() {
    }

    public mounted() {
    }
}
